import { SHELL } from './shell/shell.const';
import { DEVELOPER_ROUTES } from './developer/developer.const';
import { PROFILE_ROUTES } from './profile/profile.const';
import { PROJECT_ROUTES } from './projects/projects.const';
import { DASHBOARD_ROUTES } from './dashboard/dashboard.const';
import { HISTORIC_ROUTES } from './historic/historic.const';
import { USER_ONBOARDING_ROUTES } from './user-onboarding/user-onboarding.const';
import { USER_PROFILE_ROUTES } from './user-profile/user-profile.const';
import { RESALE_ROUTES } from './resale/resale.const';
import { DEVELOPMENT_ROUTES } from './developments/developments.const';
import { AUTH_ROUTES } from './authentication/authentication.const';
import { MORAL_ONBOARDING_ROUTES } from './moral-onboarding/moral-onboarding.const';
import { UNE_ROUTES } from './une/une.const';
import { UPDATE_INFO_ROUTES } from './update-info/update-info.const';
import { TESTIMONIES_ROUTES } from './testimonies/testimonies.const';
import { WALLET_ROUTES } from './app-v2/wallet/wallet-routing.const';
import { DASHBOARD_V2_ROUTES } from './app-v2/dashboard/dashboard-routing.const';
import { MOVES_ROUTES } from './app-v2/moves/moves-routing.const';
import { WITHDRAW_ROUTES } from './app-v2/withdraw/withdraw-routing.const';
import { MY_ACCOUNT_ROUTES } from './app-v2/my-account/my-account-routing.const';
import { MY_INVESTMENTS_ROUTES } from './app-v2/my-investments/my-investments-routing.const';
import { CALENDAR_PAYMENTS_ROUTES } from './app-v2/calendar-payments/calendar-payments-routing.const';
import { AVAILABLE_PROJECTS_ROUTES } from './app-v2/available-projects/available-projects-routing.const';

const HOME = 'home';
const LOGIN = '';

// AUTH
const REGISTRY = 'registro';
const REGISTER = 'registro';
const FORGOT_PASS = 'olvide-contrasena';
const REGISTRY_DEVELOPER = 'registro/desarrollador';

// REFERENCIADOS
const REFERENCED = 'referenciados';
const REFERENCED_USERS = '';

// AJUSTES DEL USUARIO
const USER_SETTINGS = 'configuracion';
const USER_SETTINGS_DASHBOARD = '';


// HISTORICO
const HISTORICAL = 'historico';
// const BINNACLE = 'bitacora';

// FORMULARIO PLD
const PLD = 'pd';
const PLD_FORM = 'actualizacion';
const PLD_REQUEST_UPDATE_FORM = 'w/actualizacion';

// ESTADO DE CUENTA
const ACCOUNT_STATEMENT = 'estado-de-cuenta';

export const PATH = {
  SHELL,
  HOME,
  LOGIN,
  REGISTER,
  FORGOT_PASS,

  REGISTRY,
  REGISTRY_DEVELOPER,

  PLD,
  PLD_FORM,
  PLD_REQUEST_UPDATE_FORM,

  REFERENCED,
  REFERENCED_USERS,

  ...AUTH_ROUTES,
  ...DEVELOPER_ROUTES,
  ...PROJECT_ROUTES,
  ...PROFILE_ROUTES,
  ...DASHBOARD_ROUTES,
  ...UNE_ROUTES,
  ...TESTIMONIES_ROUTES,
  ...HISTORIC_ROUTES,
  ...USER_ONBOARDING_ROUTES,
  ...USER_PROFILE_ROUTES,
  ...RESALE_ROUTES,
  ...DEVELOPMENT_ROUTES,
  ...MORAL_ONBOARDING_ROUTES,
  ...UPDATE_INFO_ROUTES,


  // Nuevas rutas v2
  ...WALLET_ROUTES,
  ...DASHBOARD_V2_ROUTES,
  ...MOVES_ROUTES,
  ...WITHDRAW_ROUTES,
  ...MY_ACCOUNT_ROUTES,
  ...MY_INVESTMENTS_ROUTES,
  ...CALENDAR_PAYMENTS_ROUTES,
  ...AVAILABLE_PROJECTS_ROUTES,

  // Ruta temporal: https://localhost:4200/estado-de-cuenta - CAMBIAR A LA RUTA DONDE SE VA ENCONTRAR EL ARCHIVO PDF
  ACCOUNT_STATEMENT,

  HISTORICAL,
  // HISTORICAL_BINNACLE,

  // CONFIGURACIÓN DEL USUARIO
  USER_SETTINGS,
  USER_SETTINGS_DASHBOARD,

  ROUTE_USER_SETTINGS: `${SHELL}/${USER_SETTINGS}`,

  ROUTE_LOGIN: `/${LOGIN}`,
  ROUTE_REGISTRY: `/${REGISTRY}`,
  ROUTE_REGISTRY_DEVELOPER: `/${REGISTRY_DEVELOPER}`,
  ROUTE_FORGOT_PASS: `/${FORGOT_PASS}`,
  /** `/s/home` */
  ROUTE_HOME: `/${SHELL}/${HOME}`,

  /** /s/referenciados/usuarios */
  ROUTE_REFERENCED_USERS: `/${SHELL}/${REFERENCED}/${REFERENCED_USERS}`,
  ROUTER_SETTINGS: `/${SHELL}/${USER_SETTINGS}`,
  // FORMULARIO PLD
  /** /pd/formulario */
  ROUTE_PLD_FORMULARIO: `/${PLD}/${PLD_FORM}`,
  /** /pd/formulario */
  ROUTE_PLD_PLD_WARNING_FORM: `/${PLD}/${PLD_REQUEST_UPDATE_FORM}`,
};
